import React from 'react';
import { IProduct } from '../../../../InvoiceCreation/types/types';

export const nameTemplate = (product: IProduct) => (
  <div className='flex items-center h-[64px]  max-w-[30ch] '>
    <p className='font-metricRSemibold text-[14px] text-bw08 ml-[24px] truncate max-w-full' title={product.name || '-'}>
      {product.name}
    </p>
  </div>
);
